<template>
 <div>
   <div @click="dialog=true" style="height: 240px" class="w-60 g-box  mb-10 ma-auto">
     <v-img class="mb-3" height="240" style="position: relative" :src="item.photo_file">
       <div class="date-box" >
         <span class="d-flex align-center justify-center">
        {{item.title}}
      </span>
       </div>
     </v-img>
   </div>
   <v-dialog persistent width="700" class="d-flex justify-center align-center text-center" v-model="dialog">
     <v-card width="700" height="100%">
       <v-app-bar style="z-index: 999999!important;">
         <h5 style="width: 100%;">{{ item.title }}</h5>
         <div style="background-color: #7BAD32;padding: 4px 16px;cursor: pointer;color: white" @click="closeDialog">
           {{ $t('close') }}
         </div>
       </v-app-bar>
       <div>
         <img v-if="item.attach_file==null" alt="image" style="object-fit: fill" :width="$vuetify.breakpoint.mdAndDown?'100%':'700'" :src="item.photo_file"/>
         <video ref="attach-video" v-else style="object-fit: fill" width="700" height="500" controls autoplay>
           <source :src="item.attach_file" type="video/mp4">
         </video>
       </div>
     </v-card>
   </v-dialog>
 </div>
</template>

<script>
export default {
  name: "BlockGalleryItem",
  data(){
    return{
      dialog:false,
    }
  },
  props:{
    item:Object
  },methods:{
    closeDialog(){
      this.dialog=false;
      this.$refs['attach-video'].pause();
      this.$refs['attach-video'].currentTime = 0;
    }
  }
}
</script>

<style scoped>
.date-box {
  padding: 6px 10px;
  text-align: center;
  position: absolute;
  bottom: 0;
  color: white;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: rgba(0, 0, 0, 0.6);
}

.g-box:hover > * > * > .date-box {
  background-color: #7BAD32;
  transition: all 0.3s cubic-bezier(0.7, 0.01, 0.3, 1);
}

.date-box > * {
  color: white;
  font-size: 16px !important;
}
</style>